export default {
  // Navigation
  nav_categories: "Kategorien",
  nav_guides: "Guides",
  nav_reviews: "Bewertungen",
  nav_shipping: "Versand",
  nav_about: "Über uns",
  nav_contact: "Kontakt",
  nav_language: "Sprache",

  // Hero Section
  hero_h1: "AllChinaBuy Spreadsheet — Produkte finden, Optionen vergleichen & smarter einkaufen",
  hero_subtitle: "Entdecken Sie AllChinaBuy Spreadsheet-Ressourcen, Produktfunde, QC-Guides, Versandinformationen, Bewertungen und Vergleiche — organisiert in einem benutzerfreundlichen Ressourcen-Hub.",
  hero_cta_primary: "AllChinaBuy Spreadsheet erkunden",
  hero_cta_secondary: "Jetzt kaufen",
  hero_search_placeholder: "Suche AllChinaBuy spreadsheet, Produkte, Versand, QC oder Guides...",

  // Category Section
  categories_title: "Beliebte Kategorien",
  categories_subtitle: "Durchsuchen Sie unsere kuratierten Produktkategorien und finden Sie die besten Angebote auf AllChinaBuy",
  category_shoes: "Schuhe",
  category_hoodies: "Hoodies / Pullover",
  category_tshirts: "T-Shirts",
  category_jackets: "Jacken",
  category_pants: "Hosen / Shorts",
  category_headwear: "Kopfbedeckungen",
  category_sets: "Sets",
  category_underwear: "Unterwäsche",
  category_jersey: "Trikots",
  category_accessories: "Accessoires",
  category_bags: "Taschen",
  category_belts: "Gürtel",
  category_perfumes: "Parfüms",
  category_other: "Sonstiges",
  category_button: "Alle durchsuchen",

  // Articles Section
  articles_title: "Neueste Guides & Ressourcen",
  articles_subtitle: "Ausführliche Artikel, die Ihnen helfen, smarter auf AllChinaBuy einzukaufen",
  article_read_more: "Guide lesen",
  article_read_time: "Min. Lesezeit",
  article_allchinabuy_spreadsheet_guide: "Vollständiger AllChinaBuy Spreadsheet-Guide",
  article_allchinabuy_spreadsheet_guide_desc: "Der ultimative Leitfaden zur Verwendung von AllChinaBuy Spreadsheet zum Finden von Produkten, Vergleichen von Preisen und Tätigen informierter Käufe im Jahr 2026.",
  article_allchinabuy_review: "AllChinaBuy Bewertung 2026",
  article_allchinabuy_review_desc: "Umfassende Bewertung mit Funktionen, Gebühren, Versandoptionen, Kundensupport und realen Nutzererfahrungen.",
  article_shipping_cost: "AllChinaBuy Versandkosten-Guide",
  article_shipping_cost_desc: "Vollständige Aufschlüsselung der Versandmethoden, Kosten nach Land und Tipps zur Reduzierung Ihrer Versandkosten.",
  article_allchinabuy_coupon: "AllChinaBuy Gutscheine & Rabattcodes",
  article_allchinabuy_coupon_desc: "Aktuelle Gutscheine, Rabattcodes und Tipps zum Geldsparen für AllChinaBuy-Käufer.",
  article_allchinabuy_vs: "AllChinaBuy vs Mitbewerber",
  article_allchinabuy_vs_desc: "Detaillierter Vergleich von AllChinaBuy mit Superbuy, CSSBuy, Sugargoo und Pandabuy.",
  article_allchinabuy_legit: "Ist AllChinaBuy legitim?",
  article_allchinabuy_legit_desc: "Sicherheitsleitfaden mit Bezahlungssicherheit, QC-Prozessen, Lagerung und wie man Betrug vermeidet.",
  article_allchinabuy_qc: "AllChinaBuy QC-Guide",
  article_allchinabuy_qc_desc: "Wie Sie den Qualitätskontroll-Service von AllChinaBuy nutzen, um Ihre Artikel vor dem internationalen Versand zu prüfen.",
  article_allchinabuy_warehouse: "AllChinaBuy Lager-Guide",
  article_allchinabuy_warehouse_desc: "Verständnis von Lagerung, Inspektion und Konsolidierungsservices bei AllChinaBuy.",

  // CTA Section
  cta_title: "Bereit, AllChinaBuy zu erkunden?",
  cta_subtitle: "Recherchieren Sie zuerst. Vergleichen Sie Optionen. Treffen Sie besser informierte Entscheidungen.",
  cta_button: "AllChinaBuy Spreadsheet",
  cta_button_secondary: "Jetzt kaufen",

  // FAQ Section
  faq_title: "Häufig gestellte Fragen",
  faq_1_q: "Was ist AllChinaBuy Spreadsheet?",
  faq_1_a: "AllChinaBuy Spreadsheet ist eine kuratierte Sammlung von Produktlinks, Preisen und Verkäuferinformationen in einem einfach zu verwendenden Format. Es hilft Käufern, die besten Angebote für Schuhe, Kleidung, Accessoires und mehr auf chinesischen Einkaufsplattformen zu finden.",
  faq_2_q: "Ist AllChinaBuy sicher zu verwenden?",
  faq_2_a: "AllChinaBuy implementiert Standard-Sicherheitsmaßnahmen einschließlich verschlüsselter Zahlungen, Lager-Qualitätskontrollen und Käuferschutzrichtlinien. Wie bei jedem internationalen Einkaufsservice empfehlen wir jedoch, Verkäufer zu recherchieren und den QC-Service (Qualitätskontrolle) vor dem internationalen Versand zu nutzen.",
  faq_3_q: "Wie viel kostet der Versand bei AllChinaBuy?",
  faq_3_a: "Versandkosten variieren je nach Zielland, Paketgewicht und Versandmethode. AllChinaBuy bietet mehrere Versandlinien einschließlich EMS, DHL, FedEx und Budgetoptionen. Nutzen Sie unseren Versandkosten-Rechner-Guide, um Kosten für Ihre spezifische Bestellung zu schätzen.",
  faq_4_q: "Bietet AllChinaBuy Gutscheine oder Rabattcodes an?",
  faq_4_a: "Ja, AllChinaBuy stellt regelmäßig Gutscheine und Werberabattcodes für neue und bestehende Kunden bereit. Überprüfen Sie unseren Gutschein-Guide für aktuelle aktive Codes und Geldsparmöglichkeiten.",
  faq_5_q: "Wie schneidet AllChinaBuy im Vergleich zu anderen Einkaufsagenten ab?",
  faq_5_a: "AllChinaBuy bietet wettbewerbsfähige Versandpreise, eine benutzerfreundliche Oberfläche und umfassende Spreadsheet-Ressourcen. Im Vergleich zu Superbuy, CSSBuy und Sugargoo hebt sich AllChinaBuy durch seine organisierten Produkt-Spreadsheets und einfache Gebührenstruktur ab. Lesen Sie unsere detaillierten Vergleichs-Guides für weitere Informationen.",
  faq_6_q: "In welche Länder versendet AllChinaBuy?",
  faq_6_a: "AllChinaBuy versendet in die meisten Länder weltweit, einschließlich USA, UK, Kanada, Deutschland, Frankreich, Dänemark, Australien und Europa. Versandzeiten und Kosten variieren je nach Zielort.",
  faq_7_q: "Kann ich eine Rückerstattung erhalten, wenn meine Bestellung falsch ist?",
  faq_7_a: "AllChinaBuy bietet Rückerstattungs- und Rückgabeoptionen je nach Verkäuferrichtlinie und Status Ihrer Bestellung. Artikel, die noch nicht aus dem Lager versendet wurden, können in der Regel zurückgegeben werden. Sobald sie international versendet wurden, werden Rückgaben komplexer und können zusätzliche Gebühren verursachen.",
  faq_8_q: "Wie verwende ich das AllChinaBuy Spreadsheet?",
  faq_8_a: "Die Verwendung des AllChinaBuy Spreadsheet ist einfach: Kategorien durchsuchen, auf Produktlinks klicken, um Artikel anzusehen, gewünschte Produkte zum Warenkorb hinzufügen und mit dem Kaufprozess fortfahren. Unser vollständiger Guide bietet Schritt-für-Schritt-Anleitungen mit Screenshots.",

  // Footer
  footer_title: "AllChinaBuy Spreadsheet",
  footer_desc: "Ihre vertrauenswürdige Ressource für AllChinaBuy-Produktrecherche, Bewertungen und Einkaufs-Guides. Wir helfen Ihnen, fundierte Entscheidungen beim Einkauf aus China zu treffen.",
  footer_links: "Schnelle Links",
  footer_resources: "Ressourcen",
  footer_legal: "Rechtliches",
  footer_privacy: "Datenschutzrichtlinie",
  footer_terms: "Nutzungsbedingungen",
  footer_disclaimer: "Haftungsausschluss",
  footer_contact: "Kontaktieren Sie uns",
  footer_copyright: "AllChinaBuy Spreadsheet. Alle Rechte vorbehalten. Dies ist eine unabhängige Informationsressource und ist nicht mit AllChinaBuy verbunden oder von AllChinaBuy betrieben, es sei denn, dies wird ausdrücklich angegeben.",

  // Article Page
  article_back_home: "Zurück zur Startseite",
  article_toc: "Inhaltsverzeichnis",
  article_last_updated: "Zuletzt aktualisiert",
  article_author: "Autor",
  article_reading_time: "Lesezeit",
  article_related: "Verwandte Artikel",
  article_faq_title: "Häufig gestellte Fragen",
  article_share: "Diesen Guide teilen",
  article_cta_text: "Bereit, mit AllChinaBuy einzukaufen?",
  article_cta_button: "AllChinaBuy Spreadsheet erkunden",
  article_cta_button_buy: "Jetzt kaufen",

  // About Page
  about_title: "Über AllChinaBuy Spreadsheet",
  about_desc: "Wir sind ein unabhängiger Ressourcen-Hub, der sich der Hilfe für Käufer beim Navigieren in der Welt chinesischer Einkaufsagenten widmet. Unsere Mission ist es, transparente, genaue und hilfreiche Informationen über AllChinaBuy und verwandte Dienste bereitzustellen.",
  about_mission: "Unsere Mission",
  about_mission_desc: "Internationale Käufer mit dem Wissen und den Werkzeugen auszustatten, die für selbstbewusste Kaufentscheidungen bei der Nutzung von AllChinaBuy und ähnlichen Einkaufsagenten-Services nötig sind.",
  about_vision: "Unsere Vision",
  about_vision_desc: "Die vertrauenswürdigste unabhängige Ressource für AllChinaBuy-Käufer weltweit zu werden, die alle Aspekte des Einkaufserlebnisses von der Produktrecherche bis zur Lieferung abdeckt.",
  about_values: "Unsere Werte",
  about_values_transparency: "Transparenz in allen Bewertungen und Vergleichen",
  about_values_accuracy: "Genaue, aktuelle Informationen",
  about_values_independence: "Unabhängigkeit von jedem Einkaufsagenten-Unternehmen",
  about_values_helpfulness: "Hilfreiche Inhalte, die echte Probleme lösen",

  // Contact Page
  contact_title: "Kontaktieren Sie uns",
  contact_desc: "Haben Sie Fragen zu AllChinaBuy? Wir sind hier, um zu helfen. Kontaktieren Sie unser Team für Anfragen, Vorschläge oder Kooperationsmöglichkeiten.",
  contact_form_name: "Ihr Name",
  contact_form_email: "E-Mail-Adresse",
  contact_form_subject: "Betreff",
  contact_form_message: "Nachricht",
  contact_form_submit: "Nachricht senden",
  contact_info: "Kontaktinformationen",
  contact_response: "Wir antworten in der Regel innerhalb von 24-48 Stunden.",

  // Breadcrumb
  breadcrumb_home: "Startseite",
  breadcrumb_article: "Artikel",
  breadcrumb_about: "Über uns",
  breadcrumb_contact: "Kontakt",
};